import { Card } from '$components'
import { ReactNode } from 'react'
import { SettingCardHeading } from './heading'
import { SettingsCardSubheading } from './subheading'
import { SettingsCardContent } from './content'

export type SettingsCardProps = {
  children?: ReactNode
}

export function SettingsCard({ children }: SettingsCardProps) {

  return (
    <Card rounding="xl">
      { children }
    </Card>
  )
}

SettingsCard.Heading = SettingCardHeading
SettingsCard.Subheading = SettingsCardSubheading
SettingsCard.Content = SettingsCardContent
